import AccordionTab from "components/util/AccordianTab";
import {Grid } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../../redux/hooks";
import { allSelectedData } from "../../../redux/slices/allSelectedDataSlice";
import { clearValidationError } from "../../../redux/slices/formValidationSlice";
import dayjs from "dayjs";
import { useParams } from "react-router-dom";

const KeyDates: React.FC<Record<any, any>> = (props) => {
    const dispatch = useDispatch();
    const selectedData = useAppSelector((state) => state.allSelectedData);
    const validationErrors = useAppSelector((state) => state.formValidation.errors);
    const {formtype } = useParams();
    const handleLeaseCommencementChange = (newValue: any) => {
        dispatch(allSelectedData({ ...selectedData, leaseCommencement: newValue ? dayjs(newValue).format('MM-DD-YYYY'): null }));
        if (newValue) {
            dispatch(clearValidationError('leaseCommencement'));
        }
    };
    
    const handleRentCommencementChange = (newValue: any) => {
        dispatch(allSelectedData({ ...selectedData, rentCommencement: newValue ? dayjs(newValue).format('MM-DD-YYYY'): null }));
        if (newValue) {
            dispatch(clearValidationError('rentCommencement'));
        }
    };
    
    const handleExpirationChange = (newValue: any) => {
        dispatch(allSelectedData({ ...selectedData, expiration: newValue ? dayjs(newValue).format('MM-DD-YYYY'): null }));
        if (newValue) {
            dispatch(clearValidationError('expiration'));
        }
    };
    
    const handleLeaseSignedByNuveenChange = (newValue: any) => {
        dispatch(allSelectedData({ ...selectedData, nuveenSigningDate: newValue ? dayjs(newValue).format('MM-DD-YYYY'): null }));
        if (newValue) {
            dispatch(clearValidationError('leaseSignedByNuveen'));
        }
    };
    
    return (
        <AccordionTab
            title={"Key Dates"} children=
            {
                <div>
                    <Grid container spacing={4} >
                        <Grid item xs={12} md={3}>
                            <Grid>
                                <label>Lease Commencement</label><span className="mandatory"> *</span>
                            </Grid>
                            <Grid>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        value={selectedData.leaseCommencement ? dayjs(selectedData.leaseCommencement):null}
                                        disabled = {formtype === "view" || formtype === "approval"}
                                        onChange={handleLeaseCommencementChange}
                                        slotProps={{
                                            textField: {
                                                size: "small",
                                                fullWidth: true,
                                                error: !!validationErrors.leaseCommencement
                                            }
                                        }}
                                    />
                                </LocalizationProvider>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <Grid>
                                <label>Rent Commencement</label><span className="mandatory"> *</span>
                            </Grid>
                            <Grid>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        value={selectedData.rentCommencement ? dayjs(selectedData.rentCommencement):null}
                                        disabled = {formtype === "view" || formtype === "approval"}
                                        onChange={handleRentCommencementChange}
                                        slotProps={{
                                            textField: {
                                                size: "small",
                                                fullWidth: true,
                                                error: !!validationErrors.rentCommencement
                                            }
                                        }}
                                    />
                                </LocalizationProvider>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <Grid>
                                <label>Expiration</label><span className="mandatory"> *</span>
                            </Grid>
                            <Grid>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        value={selectedData.expiration ? dayjs(selectedData.expiration) :null}
                                        disabled = {formtype === "view" || formtype === "approval"}
                                        onChange={handleExpirationChange}
                                        slotProps={{
                                            textField: {
                                                size: "small",
                                                fullWidth: true,
                                                error: !!validationErrors.expiration
                                            }
                                        }}
                                    />
                                </LocalizationProvider>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <Grid>
                                <label>Lease Signed By Nuveen</label><span className="mandatory"> *</span>
                            </Grid>
                            <Grid>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        value={selectedData.nuveenSigningDate ? dayjs(selectedData.nuveenSigningDate):null}
                                        disabled = {formtype === "view" || formtype === "approval"}
                                        onChange={handleLeaseSignedByNuveenChange}
                                        slotProps={{
                                            textField: {
                                                size: "small",
                                                fullWidth: true,
                                                error: !!validationErrors.leaseSignedByNuveen
                                            }
                                        }}
                                    />
                                </LocalizationProvider>
                            </Grid>
                        </Grid>
                    </Grid>
                </div>
            } />
    )
}

export default KeyDates;
